import randomAngle from "../helpers/randomAngle";
import randomSpin from "../helpers/randomSpin";
import maxSpinAfterNext from "./maxSpinAfterNext";

export default function afterNextRow(
  movePath,
  _column,
  handleFinalTouchAngle,
  startingAngle,
  rows
) {
  let touch, next, column;

  next = movePath.shift(); // 1 - right, 0 - left
  movePath.shift();
  let afterNext = movePath[0];

  column = next === "1" ? _column + 2 : _column;

  let finalAngle = randomAngle(next, afterNext, "nextRow", startingAngle);
  let spin = randomSpin(finalAngle, next, startingAngle) + 1.5; // min - 0 | max - 6
  const checkedSpin = maxSpinAfterNext(rows, spin);
  let time = 250 + checkedSpin * 50;

  touch = handleFinalTouchAngle(finalAngle);
  return [touch, checkedSpin, time, column, finalAngle];
}
